<template>
    <div class="forgotpasswordlayout">
         <span class="logintext">{{$t('Login.ResetPassword.NEW_PASSWORD_TITLE')}}</span>
          <div class="loginform">
            <v-form ref="form" v-model="valid" @keyup.native.enter="valid && send()" onSubmit="return false;" lazy-validation>
                <v-text-field v-model="password" :label="$t('Login.ResetPassword.PASSWORD_FIELD_NAME') + ' *'" @input="isCompliant" @change="isCompliant" :rules="requiredRules"  :placeholder="$t('Login.ResetPassword.PASSWORD_PLACEHOLDER')" required :type = "'password'" ></v-text-field>
                <v-text-field v-model="confirmpassword" :rules="passworConfirmationdRules" :label="$t('Login.ResetPassword.CONFIRM_PASSWORD_FIELD_NAME')" required :type = "'password'"></v-text-field>
                <div v-if="succeded">
                    <router-link  to="login" class="right">{{$t('Login.ResetPassword.BACK_TO_LOGIN_LINK')}}</router-link>
                    <br/>
                </div>
                <v-flex xs12  style="margin-top: 10px;" >
                  <v-layout row  wrap >
                  <v-flex xs12 md6 v-for="(passwordRule, index) in passwordRules" :key="index">
                    <span :class="passwordRule.isValid ?'ovalvalid' : 'oval'"></span>
                    <span :class="passwordRule.isValid ?'signuptextvalid' : ''">  {{$t(passwordRule.key)}} </span>
                    <v-tooltip v-if="passwordRule.tooltipKey" top>
                      <template v-slot:activator="{ on }">
                        <span :class="passwordRule.isValid ?'icon-attention-info-gray-valid' : 'icon-attention-info-gray'" style="font-size:16px; font-weight:bold;" v-on="on"></span>
                      </template>
                      <span>{{$t(passwordRule.tooltipKey)}}</span>
                    </v-tooltip>
                  </v-flex>
                  </v-layout>
                </v-flex>
                <v-btn block type="submit"  color="primary" @click="send">{{$t('Login.ResetPassword.SUBMIT_BTN')}}</v-btn>
            </v-form>
         </div>
    </div>
</template>
<script>
import auth from '@/services/Auth'
import { mapState } from 'vuex'

export default {
  data () {
    return {
      valid: true,
      succeded: false,
      password: '',
      confirmpassword: '',
      logo: require('@/assets/img/ehda.png'),
      passworConfirmationdRules: [
        v => !!v || this.$t('Login.ResetPassword.PASSWORD_REQUIRED_ERROR'),
        v => v === this.password || this.$t('Login.ResetPassword.CONFIRM_PASSWORD_MUST_MATCH_ERROR')
      ],
      requiredRules: [
        v => !!v || ''
      ],
      snackbarFailed: {
        show: true,
        color: 'error',
        text: this.$t('Login.ResetPassword.RESET_PASSWORD_ERROR'),
        timeout: 6000
      }
    }
  },
  methods: {
    async send () {
      if (!this.$refs.form.validate() || !this.isAllRegexValid() || !this.valid || !this.password || !this.confirmpassword) {
        return
      }

      let token = this.$route.query.token
      await auth.confirmPassword(this.password, token).then((result) => {
        this.succeded = result
        if (this.succeded) {
          setTimeout(() => this.$router.push({ path: '/login' }), 1000)
        }
      }).catch((err) => {
        console.log(err)
        this.succeded = false
        this.snackbarFailed.show = true
        this.$store.dispatch('global/setSnackbar', this.snackbarFailed)
      })
    },
    validRegex (regexUsed, text) {
      var regex = RegExp(regexUsed)
      return regex.test(text)
    },
    isCompliant () {
      this.passwordRules.forEach((passwordRule) => {
        if (passwordRule.regex !== '') {
          passwordRule.isValid = this.validRegex(passwordRule.regex, this.password)
        }
      })
    },
    isAllRegexValid () {
      let valid = true
      this.passwordRules.forEach((passwordRule) => {
        if (!passwordRule.isValid) {
          valid = false
        }
      })
      return valid
    }
  },
  computed: {
    ...mapState('accounts', ['passwordRules'])
  }
}
</script>
<style>
.fullsize {
    width: 100%;
}
</style>
